import React from 'react';

type SectionHeadingProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

// The section H2. Typography lives in `.kc-h2` (index.css) so it can scale
// fluidly and drop hand-set <br> breaks on phones; colour is inherited, which
// lets the same heading sit on the light sections and the dark Security one.
// Pass `style` for per-section spacing (marginBottom, maxWidth).
export default function SectionHeading({ children, style }: SectionHeadingProps) {
  return (
    <h2 className="kc-h2 text-balance" style={style}>
      {children}
    </h2>
  );
}
